export const encyclopediaKo = {
  // 공유
  'encyclopedia.lockAria': '잠금 — 읽으려면 잠금 해제하세요',

  // 백과사전 페이지
  'encyclopedia.page.seoTitle': '백과사전',
  'encyclopedia.page.seoDescription':
    'Grymwyrd의 살아있는 마법서를 검색하세요 — 괴물, 주문, 종족, 아이템, 장소 등.',
  'encyclopedia.page.heading': '백과사전',
  'encyclopedia.page.subtitle': 'Grymwyrd의 모든 공포, 주문, 그리고 전설의 살아있는 마법서.',
  'encyclopedia.page.searchPlaceholder': '{plural} 검색…',
  'encyclopedia.page.searchAria': '{plural} 검색',
  'encyclopedia.page.clearSearch': '검색 지우기',
  'encyclopedia.page.systemNotLivePrefix': '베일이 아직',
  'encyclopedia.page.systemNotLiveSuffix':
    '를(을) 위해 열리지 않았습니다. 이 의식에 얽힌 지식은 흘러나오지 않았으며, 그 마법서는 어둠 너머에서 기다립니다.',
  'encyclopedia.page.returnToAllSystems': '모든 체계로 돌아가기',
  'encyclopedia.page.settingNotLivePrefix': '',
  'encyclopedia.page.settingNotLiveSuffix':
    '의 땅은 여전히 지도로 그려지고 있습니다 — 그 항목들은 아직 설정에 연결되지 않았습니다. 지도 제작자들이 완성될 때까지, 여기에 응하는 것은 없습니다.',
  'encyclopedia.page.returnToAllRealms': '모든 영역으로 돌아가기',
  'encyclopedia.page.filteringBy': '필터링 기준',
  'encyclopedia.page.filterSystem': '체계 "{label}"',
  'encyclopedia.page.filterCanon': '정사 계층 "{label}"',
  'encyclopedia.page.filterSetting': '설정 "{label}"',
  'encyclopedia.page.canonNote': '정사 계층은 항목이 API에서 태그되면 적용됩니다 (참조 _docs/13). ',
  'encyclopedia.page.clear': '지우기',
  'encyclopedia.page.hide': '숨기기',
  'encyclopedia.page.filter': '필터',

  // 항목 카드
  'encyclopedia.entityCard.unlockAria': '{name} 잠금 해제 (Grymwyrd 콘텐츠)',
  'encyclopedia.entityCard.viewAria': '{name} 항목 보기',

  // 항목 그리드
  'encyclopedia.grid.paginationAria': '페이지 매김 ({position})',
  'encyclopedia.grid.prev': '이전',
  'encyclopedia.grid.next': '다음',
  'encyclopedia.grid.pageOf': '페이지 {page}/{totalPages}',
  'encyclopedia.grid.resultsAria': '{plural} 결과',
  'encyclopedia.grid.scrying': '기록 탐색 중…',
  'encyclopedia.grid.count': '{total}개의 {plural}',
  'encyclopedia.grid.sortDescAria': '내림차순 정렬',
  'encyclopedia.grid.sortAscAria': '오름차순 정렬',
  'encyclopedia.grid.sortAZ': 'A–Z',
  'encyclopedia.grid.sortZA': 'Z–A',
  'encyclopedia.grid.viewModeAria': '보기 모드',
  'encyclopedia.grid.gridViewAria': '격자 보기',
  'encyclopedia.grid.listViewAria': '목록 보기',
  'encyclopedia.grid.jumpToLetterAria': '문자로 이동',
  'encyclopedia.grid.all': '모두',
  'encyclopedia.grid.letterSymbolAria': '숫자 또는 기호로 시작하는 항목',
  'encyclopedia.grid.letterAria': '{letter}(으)로 시작하는 항목',
  'encyclopedia.grid.emptyTitle': '기록관이 잠잠하다',
  'encyclopedia.grid.emptyForLetter': '"{letter}"로 시작하는 이름의 {plural}이(가) 없습니다.',
  'encyclopedia.grid.emptyAll': '당신의 부름에 응하는 {plural}이(가) 없습니다.',
  'encyclopedia.grid.turningPages': '페이지를 넘치는 중…',

  // 항목 이미지
  'encyclopedia.entityImage.noArtworkAria': '{label} (미술 작품 없음)',
  'encyclopedia.entityImage.noVision': '시각 자료 없음',

  // 면 사이드바
  'encyclopedia.facets.all': '모두',
  'encyclopedia.facets.soon': '곧 출시',
  'encyclopedia.facets.navAria': '항목 유형 필터',
  'encyclopedia.facets.clearAll': '모든 필터 지우기',
  'encyclopedia.facets.lorebook': '전승록',
  'encyclopedia.facets.gameSystem': '게임 체계',
  'encyclopedia.facets.canonLayer': '정사 계층',
  'encyclopedia.facets.setting': '설정',

  // 전역 검색
  'encyclopedia.globalSearch.title': '베일 검색',
  'encyclopedia.globalSearch.placeholder': '괴물, 주문, 장소, 전설 검색…',
  'encyclopedia.globalSearch.queryAria': '검색 쿼리',
  'encyclopedia.globalSearch.loading': '탐색 중…',
  'encyclopedia.globalSearch.empty': '"{q}"에 대해 어둠 속에서 아무것도 깨어나지 않습니다.',

  // 잠금 콘텐츠 — 잠금 배지
  'encyclopedia.lockBadge.title': 'Grymwyrd 콘텐츠 — 읽으려면 잠금 해제하세요',
  'encyclopedia.lockBadge.label': '잠금',
  // 잠금 콘텐츠 — 잠금 게이트
  'encyclopedia.lockedGate.regionAria': '잠금 콘텐츠',
  'encyclopedia.lockedGate.defaultTitle': '이 지식은 봉인되어 있습니다',
  'encyclopedia.lockedGate.body':
    "Grymwyrd의 괴물도감, 주문, 그리고 전설은 Grymwyrd 대격변에 얽혀 있습니다. 공개 SRD 정사는 자유로 유지되지만, 영원한 황혼 자체를 걸으려면 그 책을 얻어야 합니다.",
  'encyclopedia.lockedGate.unlockCta': 'Grymwyrd 잠금 해제',
  'encyclopedia.lockedGate.signInCta': '이미 후원자인가요? 로그인하세요',
  'encyclopedia.lockedGate.backerNote':
    'Grymwyrd를 위해 후원한 후원자는 이미 이것을 소유하고 있습니다 — 계정에서 잠금을 해제하려면 로그인하세요.',

  // 표 보기
  'encyclopedia.table.rollToastTitle': '{name} — {total} 굴림',
  'encyclopedia.table.noRowMatched': '{total}과(와) 일치하는 행이 없습니다.',
  'encyclopedia.table.loading': '표를 펼치는 중…',
  'encyclopedia.table.error': '이 표를 그릴 수 없습니다.',
  'encyclopedia.table.roll': '{formula} 굴리기',
  'encyclopedia.table.lastRoll': '마지막 굴림: {value}',
  'encyclopedia.table.noMatchingRow': ' · 일치하는 행 없음',

  // 항목 상세 페이지
  'encyclopedia.detail.entryFallback': '항목',
  'encyclopedia.detail.addedToCampaign': '캠페인에 추가되었습니다.',
  'encyclopedia.detail.addError': '캠페인 보관소에 연결할 수 없습니다. 나중에 다시 시도하세요.',
  'encyclopedia.detail.unknownType': '알 수 없는 항목 유형입니다.',
  'encyclopedia.detail.seoDescription': '{name} — Grymwyrd 백과사전의 {label}.',
  'encyclopedia.detail.breadcrumbAria': '이동 경로',
  'encyclopedia.detail.breadcrumbRoot': '백과사전',
  'encyclopedia.detail.sourceVersionAria': '출처 버전',
  'encyclopedia.detail.versionConsolidated': '통합됨',
  'encyclopedia.detail.versionBook': '특정 책',
  'encyclopedia.detail.removeBookmarkAria': '북마크 제거',
  'encyclopedia.detail.addBookmarkAria': '북마크 추가',
  'encyclopedia.detail.bookmarked': '북마크됨',
  'encyclopedia.detail.bookmark': '북마크',
  'encyclopedia.detail.addToCampaign': '캠페인에 추가',
  'encyclopedia.detail.sealedTitle': '{name}은(는) 봉인되어 있습니다',
  'encyclopedia.detail.bookVariantNote':
    '통합 기록을 표시하고 있습니다. 책 판본이 연결되면 책별 변형 텍스트가 여기에 나타날 것입니다.',
  'encyclopedia.detail.tablistAria': '항목 섹션',
  'encyclopedia.detail.tab.lore': '전승',
  'encyclopedia.detail.tab.stats': '능력치',
  'encyclopedia.detail.tab.gallery': '갤러리',
  'encyclopedia.detail.tab.relations': '관계',
  'encyclopedia.detail.tab.discussions': '토론',
  'encyclopedia.detail.tab.claims': '플레이어 주장',
  'encyclopedia.detail.loading': '항목을 깨우는 중…',

  // tabs/LoreTab
  'encyclopedia.lore.loading': '전승을 발굴하는 중…',
  'encyclopedia.lore.empty': '이 항목의 역사는 아직 기록되지 않았습니다.',

  // tabs/StatsTab
  'encyclopedia.stats.loading': '룬을 읽는 중…',
  'encyclopedia.stats.empty': '이 항목에 대해 기록된 역학은 없습니다.',

  // tabs/GalleryTab
  'encyclopedia.gallery.loading': '시각 자료를 개발하는 중…',
  'encyclopedia.gallery.emptyTitle': '아직 시각 자료 없음',
  'encyclopedia.gallery.emptyBody': '이 항목에 연결된 미술 작품이 없습니다. 보관소에서 하나를 기여하세요.',
  'encyclopedia.gallery.artworkAlt': '항목 미술 작품',

  // tabs/DiscussionsTab
  'encyclopedia.discussions.loading': '속삭임을 모으는 중…',
  'encyclopedia.discussions.emptyTitle': '전당의 침묵',
  'encyclopedia.discussions.emptyBody': '동료 방랑자들과 이 항목에 대해 이야기할 첫 번째 사람이 되세요.',
  'encyclopedia.discussions.startCta': '토론 시작',
  'encyclopedia.discussions.untitledThread': '제목 없는 스레드',
  'encyclopedia.discussions.byAuthor': '{author}가 작성함',
  'encyclopedia.discussions.replyCount': '{count}개의 댓글',

  // tabs/ClaimsTab
  'encyclopedia.claims.recorded': '당신의 주장이 검토를 위해 기록되었습니다.',
  'encyclopedia.claims.recordError': '기록관이 당신의 주장을 기록할 수 없었습니다. 나중에 다시 시도하세요.',
  'encyclopedia.claims.loading': '정사를 참조하는 중…',
  'encyclopedia.claims.emptyTitle': '아직 플레이어 주장 없음',
  'encyclopedia.claims.emptyBody': '아직 어떤 방랑자도 이 항목에 그들의 전설을 엮지 않았습니다.',
  'encyclopedia.claims.claimCta': '이것을 주장하다',
  'encyclopedia.claims.signInCta': '주장하려면 로그인하세요',
  'encyclopedia.claims.untitledClaim': '제목 없는 주장',
  'encyclopedia.claims.byAuthor': '{author}가 작성함',
  'encyclopedia.claims.addCta': '당신의 주장을 추가하세요',

  // tabs/RelationsTab
  'encyclopedia.relations.thisEntry': '이 항목',
  'encyclopedia.relations.relationLabel': '관계 {index}',
  'encyclopedia.relations.kindredLabel': '동족 {index}',
  'encyclopedia.relations.loading': '운명의 실을 따라가는 중…',
  'encyclopedia.relations.hintIntro': '그 항목으로 이동하려면 노드를 클릭하세요. 표시된 실은',
  'encyclopedia.relations.hintCanonical': ' 정사의 관계입니다.',
  'encyclopedia.relations.hintKindred': ' 같은 유형의 동족입니다.',
} as const
